<div class="item" style="height: calc(100vh - 400px); position: relative">
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <div class="table-container">
    <table class="table-header">
      <colgroup>
        <col *ngFor="let col of tableHeader" [width]="col.width"/>
      </colgroup>
      <thead>
        <tr>
          <th *ngFor="let header of tableHeader" [sortable-column]="header.value"> 
            <div>{{header.name}}</div>
          </th>
        </tr>
      </thead>
    </table>
    <div class="alternative-contents" *ngIf="determineElementToShow() === 'no-data'"> <i class="material-icons">inventory_2</i>
      <div>No Data</div>
    </div>
    <div class="table-body" *ngIf="determineElementToShow() === 'normal'">
      <table>
        <colgroup>
          <col *ngFor="let col of tableHeader" [width]="col.width"/>
        </colgroup>
        <tbody>
          <tr *ngFor="let note of responseNoteList">
            <td>{{note?.name}}</td>
            <td>
              <ng-container *ngIf="hasUpdatePermission || hasDeletePermission">
                <div class="more-content v-center" #actionMenus [id]="'target-'+ note.response_id" (mouseover)="setMorePosition(note.response_id)">
                  <div class="more-selector" (click)="$event.stopPropagation();toggleMenu(note)">
                    <comp-icon [icon]="'more_horiz'" [size]="20" [color]="'hsla(0, 0%, 0%, 0.87)'"></comp-icon>
                  </div>
                  <div class="more" [class.show]="note.isShowMenu" [id]="'target-more-'+note.response_id">
                    <div class="more-item row" *ngIf="hasUpdatePermission" (click)="openEditDialog($event, note)">
                      <div>Edit</div>
                    </div>
                    <div class="more-item row txt-danger" *ngIf="hasDeletePermission" (click)="openDeleteDialog($event, note)">
                      <div>Delete</div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>